// src/pages/Following.jsx
import "../assets/stylesheets/following.css";

export default function Following() {
  return (
    <>
      <section className="page-heading">
        <h1>Following</h1>
        <p>Check out who you're following, and what they're listening to!</p>
      </section>

      <main className="profile-grid">{/* Map profiles here later */}</main>
    </>
  );
}
